<template>
  <v-dialog
    v-model="value"
    max-width="500px"
  >
    <v-card>
      <BarTitleDialog
        title="Pagamento Por Pix"
        @close="$emit('input', false)"
      />

      <v-card-text>
        <v-row>
          <v-col class="text-left text">
            Valor a pagar
          </v-col>
          <v-col class="text-right text">
            R$ {{ formatMoney(remainingValueSeparate) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <SelectPix
              v-model="pixKey"
              class="mb-2"
              :error_messages="errorPixKey"
            ></SelectPix>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <vuetify-money
              v-model="payValue"
              :error-messages="validPayValue"
              outlined
              label="Valor pago pelo cliente"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn
              text
              x-large
              @click="close()"
            >
              Cancelar
            </v-btn>
            <v-btn
              class="ml-2"
              color="primary"
              x-large
              @click="addPayment()"
            >
              Receber
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiWindowClose,
} from '@mdi/js'
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex'

import BarTitleDialog from '@/components/BarTitleDialog.vue'
import SelectPix from '@/components/SelectPix.vue'

export default {
  components: {
    BarTitleDialog,
    SelectPix,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    errorPixKey: '',
    pixKey: null,
    valueValid: [],
    payValue: 0,
    change: 0,
    loading: false,
    auxValues: [],
    data: {
      deposit: 0,
      obs: '',
    },

    icons: {
      mdiWindowClose,
    },
  }),
  watch: {
    value(val) {
      if (val) {
        this.generateValues()
        this.payValue = this.remainingValueSeparate
      }
    },
    pixKey() {
      this.errorPixKey = ''
    },
  },

  created() {

  },
  computed: {
    ...mapGetters('checkout', ['getTotalToPay', 'remainingValueSeparate']),
    validPayValue() {
      if (this.payValue <= 0) {
        return this.valueValid = ['Quantia deve ser 0.01 ou superior']
      }

      return []
    },
    labelChange() {
      if (this.change <= 0) {
        return 'Sem troco'
      }

      return `Troco: ${this.formatMoney(this.change)}`
    },

  },
  methods: {
    ...mapMutations('checkout', ['addPaymentMethodSeparate', 'setStage']),

    applyValue(val) {
      this.payValue = val

      // this.change = val - this.getTotal
    },
    close() {
      this.$emit('input', false)
    },
    generateValues() {
      let auxValue = this.remainingValueSeparate

      // primeira tecla
      this.auxValues[0] = auxValue

      // segunda tecla
      auxValue = Math.ceil(auxValue / 5) * 5
      this.auxValues[1] = auxValue

      // terceira tecla
      this.auxValues[2] = auxValue * 2

      // quarto tecla
      this.auxValues[3] = auxValue * 3

      // quita tecla
      this.auxValues[4] = auxValue * 4

      // sexta
      this.auxValues[5] = this.auxValues[4] * 2
    },
    addPayment() {
      if (this.pixKey == undefined || this.pixKey == null) {
        this.errorPixKey = 'Chave Pix é obrigatório'

        return false
      }

      const paymentMethod = {
        pix_id: this.pixKey,
        method: 'pix',
        value: this.payValue,
      }

      this.addPaymentMethodSeparate(paymentMethod)
      this.close()

      // if (this.remainingValue > 0) { // se existe valor restante vai para a pagina de mutiplas formas de pagamento
      //     this.setStage('multiple_payment_methods')
      // }
    },
    formatMoney(value) {
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },
  },

}
</script>

<style scoped>
.text {
    color: black;
    font-size: large;
}

.card {
    height: 67px;
    cursor: pointer;
    border: solid 1px black;
}

.change {
    color: blueviolet;
    font-size: medium;
}

.card:hover {
    background: rgb(248, 248, 248);
}
</style>
